import Env from "@/utils/env"

export const appLauncherDownloadLink = Env.VUE_APP_LAUNCHER_DOWNLOAD_LINK
export const launchPadDocumentation = Env.VUE_APP_DOCUMENTATION_LINK
